import { BaseComponent } from '../../base-component';
import { waitForAllPreloadedScriptsToBeLoaded } from '../../_common/client/otto-preloaded-scripts-helper';
import { ZoomImageElement } from '../../_feature-components/zoom-image/zoom-image.element';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class ImageGalleryComponent extends BaseComponent {
    public rootSelector = '.js_pdp_image-gallery';
    private didZoomImage = false;

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        await waitForAllPreloadedScriptsToBeLoaded();
        const rootElement = this.getRootElement();
        const rootElementHeight = rootElement.getBoundingClientRect().height;
        const numberOfImages = rootElement?.dataset?.imageCount;

        trackView({
            product_ImageGalleryHeight: [rootElementHeight.toFixed(0)],
            product_ImageGalleryCount: [String(numberOfImages)],
        });

        this.getRootElement().addEventListener(ZoomImageElement.EVENT_OPENED, () => {
            if (this.didZoomImage) return;
            this.didZoomImage = true;
            trackEvent({
                product_ImageGalleryZoom: ['pinch'],
            });
        });
    }
}
